import React from "react";
import { getFlagBagFromStation } from "services/api";
import { useAuth } from "store/AuthProvider";
import { useData } from "store/DataProvider";
import {
	convertComingStatusListLocalToServerStatusList,
	getComingStatusListLocal,
} from "utils/flagbagStatusUtils";
import { useSync } from "store/SyncContext";
import { enqueueSnackbar } from "notistack";
import { initIndexedDbIfMissingStore } from "utils/indexedDbRecovery";


const useDataController = () => {
	const db = initIndexedDbIfMissingStore("records");
	const auth = useAuth();
	const data = useData();
	const { isSyncing, setIsSyncing, lastUpdateDate, setLastUpdateDate } = useSync();

	const syncTime = (jObj) => {
		const timeNow = Date.now(); // Get current time in milliseconds
		const currentTimestampInSeconds = Math.floor(timeNow / 1000);
		
		// Handle both old and new API response formats
		const serverTimestamp = jObj.currentTimestamp || currentTimestampInSeconds;
		const lastUpdatedTimestamp = jObj.lastUpdatedTimestamp || currentTimestampInSeconds;
		
		let output: any = {
			fasterThanServerTime: currentTimestampInSeconds - serverTimestamp,
			flagBagLastUpdateTime: lastUpdatedTimestamp,
			LastUpdateTimeLocalTime: timeNow,
		};

		const timeBank = jObj.excessQuotaTimestamp;
		if (timeBank > 0) {
			output.reachedBankQuotaPopUpTimestamp = timeBank;
		}
		
		return output;
	};

	const getDataByStationId = (stationID: string) => {
		return db.getByID(stationID).then((data) => {
			return data;
		});
	};

	const updateData = (obj) => {
		const stationId = data.getStationId();
		db.getByID(stationId).then((dbData) => {
			db.update({ id: stationId, ...dbData, ...obj });
		});
	};

	const updateFlagBagAction = async (stationID: string) => {
		if (!stationID) {
			console.warn("updateFlagBagAction: stationID is required");
			return;
		}

		if (isSyncing) {
			enqueueSnackbar("正等待同步", { variant: "info" });
			return;
		}
		
		const eventId = data.getEventId();
		
		if (!eventId) {
			console.warn("updateFlagBagAction: eventId is not available");
			enqueueSnackbar("活動資訊不完整，無法更新旗袋數據", { variant: "warning" });
			return;
		}

		return new Promise<any>((res, rej) =>
			getFlagBagFromStation(eventId, stationID)
				.then((resp) => {
					const timeObj = syncTime(resp);
					const updateValue = { id: stationID, ...timeObj, ...resp };
					const lastDate = new Date(updateValue.LastUpdateTimeLocalTime);
					setLastUpdateDate(lastDate);
					res(updateValue);
				})
				.catch((error) => {
					rej(error);
				})
		);
	};

	const convertComingStatusListLocalToServerSTatusList = convertComingStatusListLocalToServerStatusList;

	return { getDataByStationId, syncTime, updateData, updateFlagBagAction, getComingStatusListLocal, convertComingStatusListLocalToServerSTatusList };
};

export default useDataController;
